import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import PictureViewer from "./PictureViewer"
import TextViewer from "./TextViewer"
import { searchHighlightFilter } from "../../../../actions/highlightActions"

const PictureViewerWrapper = (props) => {
	const dispatch = useDispatch()
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const { documentDetails, documentLoading } = useSelector((state) => state.documentModal)

	useEffect(() => {
		const filterData = { ...highlightFilter }
		filterData["nativeView"] = true
		dispatch(searchHighlightFilter(filterData))
	}, [])
	return highlightFilter?.nativeView ? <PictureViewer /> : <TextViewer />
}

export default PictureViewerWrapper
